module.exports = __webpack_public_path__ + "static/pic01-4cd67573447d2e02001b89e70dd55c61.jpg";